
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { get } from "lodash";
import { FeaturesList } from "@/store/types";
import EventAlarmTagsTooltip from "./EventAlarmTagsTooltip.vue";

const BUTTON_PRIMARY = "primary";
const BUTTON_SECONDARY = "secondary";

@Component({
    components: {
        "event-alarm-tags-tooltip": EventAlarmTagsTooltip
    }
})
export default class EventAlarmTagsButtonAndTooltip extends Vue {

    @Getter("getFeaturesList") featuresList!: FeaturesList;

    @Prop({type: Number, required: false})
    private eventId: number;
    
    @Prop({type: Number, required: false})
    private groupId: number;

    private isEventAlarmTagsTooltipVisible: boolean = false;

    @Prop({type: Boolean, required: false})
    private isPostEventEdit: boolean;

    protected get isAlarmTagsEnabled(): boolean {
        return get(this.featuresList, ["Alarms", "AlarmTags"]);
    }

    private get buttonVariant(): string {
        return this.isEventAlarmTagsTooltipVisible ? BUTTON_PRIMARY : BUTTON_SECONDARY;
    }

    private toggleEventAlarmTagsTooltip(): void {
		this.isEventAlarmTagsTooltipVisible = !this.isEventAlarmTagsTooltipVisible;
	}
}
